module.exports = __webpack_public_path__ + "img/rooms-banner.dcb41a7d.png";